/**
 * Which household member the logged-in guardian is currently viewing. `null`
 * means their own profile. Held in memory for the API layer (which attaches
 * `X-Acting-Client` to every request while it is set) and mirrored to
 * localStorage so a reload stays on the same profile.
 *
 * The stored value is only a hint: AuthContext re-validates it against the
 * guardian's live household before applying it, so a stale or tampered id can
 * never reach the API (the server re-checks every request anyway).
 */
const STORAGE_KEY = 'brainkey-client.actingClientId';

let current: string | null = null;

export function readStoredActingClientId(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null; // storage disabled — degrade to "own profile"
  }
}

function writeStored(id: string | null): void {
  try {
    if (id === null) window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
}

export const actingClient = {
  get(): string | null {
    return current;
  },

  set(id: string | null): void {
    current = id;
    writeStored(id);
  },
};
